export default {
  "1a": {
    description: "Grapje!",
    pageExists: true
  },
  "1b": {
    description: "Geinig toch?",
    pageExists: false
  },
  "2a": {
    description: "Nog een poging!",
    pageExists: false
  }
};



// WEBPACK FOOTER //
// ./src/data/leerdoelen-grieks.js